// Pre-warm images inside hidden tab panels so the first switch doesn't jump
// while images decode. Runs once on idle after page load.
(() => {
  const prewarm = () => {
    const imgs = document.querySelectorAll('[data-tab-panel][hidden] img[loading="lazy"]');
    imgs.forEach((img) => {
      img.setAttribute('loading', 'eager');
      const src = img.currentSrc || img.src;
      if (!src) return;
      const probe = new Image();
      if (img.srcset) probe.srcset = img.srcset;
      if (img.sizes) probe.sizes = img.sizes;
      probe.src = src;
    });
  };
  const schedule = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prewarm, { timeout: 2000 });
    } else {
      setTimeout(prewarm, 600);
    }
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
